// extracted by mini-css-extract-plugin
export default {"wrapper":"products_wrapper__XZzCo","title":"products_title__lFli7","productWrapper":"products_productWrapper__RbloJ"};